export default __webpack_public_path__ + "static/media/Immobilizer.46c72620.svg";